<template>
    <div class="vue-order-line-item col-12">
        <div class="row mt-4 mb-5 px-3">
            <div class="col-12 divider-col">
                <div class="divider"></div>
            </div>
        </div>
        <div class="row d-flex align-items-center px-3 flex-nowrap">
            <div class="col-xl-2 col-md-4 col-3">
                <img :src="item.model.translation.image" :alt="item.model.sku">
            </div>

            <div class="col-xl-5 col-md-8 col-9">
                <h5 class="item-title">{{ item.model.translation.name }}</h5>
                <span class="meta-info">{{ articleNumberLabel }} {{ displayedArticleNumber }}<span v-if="item.volume"> - {{ item.volume }}</span></span>
            </div>

            <div class="col col-xl-2 mt-5 mt-xl-0" v-if="item.quantity">
                {{ amountText }} {{ item.quantity }}
            </div>

            <div class="col mt-5 mt-xl-0" v-if="item.total_unit_price">
                {{ item.total_unit_price/100|currencyFormatter }}
            </div>

            <div class="col mt-5 mt-xl-0" v-if="item.total_net_price">
                <span class="font-weight-bold">
                    {{ item.total_net_price/100|currencyFormatter }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import CurrencyFormatter from "../mixins/currency-formatter";
import articleNumber from "../mixins/article-number";

export default {
    name: "OrderLineItem",

    mixins: [CurrencyFormatter],

    props: {
        item: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            amountText: window.Drupal.t('amount:'),
        }
    },

    computed: {
        articleNumberLabel() {
            const model = this.item && this.item.model ? this.item.model : {};
            return articleNumber.methods.getArticleNumberLabel(model);
        },
        displayedArticleNumber() {
            const model = this.item && this.item.model ? this.item.model : {};
            return articleNumber.methods.getDisplayedArticleNumber(model);
        }
    }
}
</script>
